<template>
    <div class="modal fade" :id="idModalView" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" :class="{ 'modal-lg':isXl }">
            <div class="modal-content" :class="[is_loading ? 'loading':'']">
                
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalCenterTitle">{{ title }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                </div>
                <div class="modal-body">
                        <div v-html="content"></div>
                </div>
                <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

export default {
    name:'modal-report',
    props:{
        idModalView:String,
        title:String,
        content:String,
        isXl:Boolean
    },
    data(){
        return {
            is_loading:false
        }
    },
    methods:{
        
    }
    
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/modal/modalView.vue